export const DEFAULT_PLACEHOLDER = '0';
export const DEFAULT_DECIMAL_PLACEHOLDER = `${DEFAULT_PLACEHOLDER}.`;
export const JAVASCRIPT_DECIMAL_SEPARATOR = '.';
export const NUMBER_REGEX = /\d/;
export const JAVASCRIPT_DECIMAL_SEPERATOR_REGEX = new RegExp(`\\${JAVASCRIPT_DECIMAL_SEPARATOR}`);
export const NEGATIVE_SIGN = '-';
